import { useCallback } from "react";

/**
 * Obtiene los datos de un endpoint y los transforma en una lista
 * @template T Retorno de endpoint
 * @template U Retorno de función de transformación
 * @param {Promise<T>} request Endpoint a ejecutar
 * @param {(value: T) => U} transformFn Función de transformación de datos
 * @param {U[] | (data: U[]) => U[]} initArray Array inicial
 * @param {(value: U) => bool} filter Filtro de array resultado de promesa
 * @param {any[]} params Parámetros de endpoint
*/
const useGetArrayPromise = (request = () => {}, transformFn = (value) => ({}), initArray = [], filter = (arr) => (true), ...params) => {

    /**
     * Promesa de retorno
     * @type {() => Promise<U[]>}
     */
    const promise = useCallback(() => {
        return new Promise(async resolve => {
            const [res] = await request(...params);
            if (res?.data) {
                if (Array.isArray(initArray)) {
                    const data = [...initArray, ...res.data.map(transformFn)];
                    resolve(data.filter(filter));
                } else {
                    const data = initArray(res.data.map(transformFn));
                    resolve(data);
                }
                
            } else {
                resolve([]);
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...params]);
  
    return {
      promise,
    };
};

export default useGetArrayPromise;